<template>
  <div class="material-mask" v-if="show">
    <div class="material-dialog">
      <div class="material-hd">
        <h3>选择素材</h3>
        <i class="icon-shiti_guanbitouping closed"  @click="onCancel"></i>
      </div>
      <div class="material-bd">
        <div class="material-panel">
          <div class="material-grid">
            <div class="material-menu">
              <div class="munu-box ">
                  <div class="group-list">
                   <template v-for="(item, index) in grouplist">
                       <div class="item":class="{current:item.select}"  @click="groupEvent(index)" ><span>{{item.name}}</span><em>({{item.count}})</em></div>
                    </template>
                    </div>
              </div>
              <div class="category_add"  @click="categoryGroup">
                <div class="popover_wrp">
                  <span>新建分组</span>
                  <div class="material-popover" :style="[meunMode.show?popover.showStyle:popover.hideStyle]">
                    <div class="popover_inner">
                      <div class="popover_context">
                        <div class="form_group">
                          <label class="form_label">创建分组</label>
                          <div class="form_input">
                            <span class="form_input-wrp">
                              <input type="text" name="group_name" placeholder v-model="meunMode.name" />
                            </span>
                            <p class="form_msg_warn" v-show="meunMode.tipshow">分组名为1-6个字符</p>
                          </div>
                        </div>
                      </div>
                      <div class="popover_bar">
                         <Button type="primary" @click="oKCategoryGroup">确定</Button>
                         <Button @click="cancelCategoryGroup">取消</Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="material-context">
              <div class="material-bar">
                <div class="tips">
                  大小不超过10M，{{watermarkSwitch==0?'已关闭图片水印':'水印已开启'}} 
                  <div class="popover_wrp tipsbox">
                    <i class="icon-yiwen"></i>
                    <div class="material-popover">
                      <div class="popover_inner">
                        <div class="popover_context">
                          <p> {{watermarkSwitch==0?'添加水印':'不添加水印'}} </p>
                          <p style="color: rgb(151, 164, 164);">
                            <span>已关闭水印，{{watermarkSwitch==0?'已关闭水印，所有上传的图片都不会带有水印。':'水印已启用，所有上传的图片都带有水印。'}}</span>若需修改请前往
                            <a target="_blank" href="/#/sys/sysconfig">系统设置/文件上传设置</a>设置图片水印
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="operate-box">
                  <input type="file"  @change="UploadFile"  id="material" class="material" multiple="multiple"  accept="image/bmp, image/png, image/jpeg, image/jpg, image/gif" style="display: none;"/>
                  <span class="file-btn" onclick="material.click()" v-show="hideUploadButton==false" >上传文件</span>
                </div>
              </div>
              <div class="material-imglist" >
                    <template v-if="materialLoading">
                    <template v-for="(item, index) in imglist"  >
                        <template v-if="item.type=='progress'"  >
                            <div class="wrap-item img-item">
                                <div class="upload-status">
                                    <div class="progressbox">
                                        <span :style="'width:'+item.progress+''"></span>
                                    </div>
                                </div>
                                <strong>{{item.name}}</strong>
                            </div>
                        </template>
                        <template v-else-if="item.type=='error'"  >
                            <div class="wrap-item img-item">
                                <div class="upload-status">
                                    <div class="error-text">
                                        <span>{{item.msg}}</span>
                                        <span class="del" @click="delUploadFailed"><i>删除</i></span>
                                    </div>
                                </div>
                                <strong>{{item.name}}</strong>
                            </div>
                        </template>
                        <template v-else >
                            <div class="wrap-item img-item" :class="{'selected':item.select,'disabled':(!item.select && isDisabled)}" @click="SelectImage(index)"> 
                                <i class="img"  :style="'background-image: url('+$config.imgDomain+item.imgUrl+');'"></i> 
                                <span class="checkbox"></span> 
                                <strong>{{item.name}}</strong> 
                            </div>
                        </template>
                    </template>
                    </template>
                <div v-else class="material-loading">加载中</div>
                </div>
              <div class="material-pagination pagebox" v-show="isShowSelect===false" ><Page ref="pagefun" :totalCount="totalCount" :pageSize="pageSize" :limits="false" :refresh="false" @on-change="PgaeCallback" ></Page></div>
            </div>
          </div>
        </div>
      </div>
      <div class="material-ft">
        <div class="calculate">
          已选择
          <span @click="showSelect">{{selectImageCount}} / {{opt_limit}} 项</span>
          <span @click="closeSelect" v-show="isShowSelect">返回全部</span>
        </div>
        <div class="operate">
           <Button type="primary"  @click.native="ok"  >确定</Button>
           <Button @click="onCancel">取消</Button>
        </div>
        <div class="other"></div>
      </div>
    </div>
    <div class="material-toptips" style="display:none">
      <span class="material-error">发生了未知的错误</span>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import {deepClone } from '@/utils/utils';//A.引用其中某几个方法
    export default {
        props: {
            opt_limit: {
                type: Number,
                default: 1
            },
            onOk:{
                type:Function
            }
        },
        data () {
            return {
                show:true,
                mid: 0,//分组ID
                imglist: new Array(),//当前图片数据
                grouplist: new Array(),//当前菜单数据
                fileCount: 0,//单次选择图片数量
                updateCount: 0,//上传成功统计
                selectImage: new Array(),//所选择的图片
                selectImageCount:0,//所选图片数量
                isShowSelect:false,//显示所选择的图片
                page:1,
                pageSize: 18,//每页条数
                fileMaxCount: 9,//一次性最多上传图片数量
                materialLoading:false,//加载效果
                isDisabled:false,//禁止选择

                init:true,//首次加载初始化基本数据
                watermarkSwitch:0,//水印类型，0为关闭，1为文字，2为图片
                //recentTotal:0,//最新使用的
                totalCount:0,//分页数据总数
                popover:{
                    showStyle:{
                            opacity:1,
                            visibility:"visible",
                            zIndex:1
                        },
                    hideStyle:{
                            opacity:0,
                            visibility:"visible",
                            zIndex:0
                    }
                },
                meunMode:{
                    show:false,
                    name:"",
                    tipshow:false,
                },
                Copy_selectImage: new Array(),//临时保存
                hideUploadButton:false//隐藏上传按钮
            }
            
        },
        computed: {

        },
        methods: {
            ok () {
                 // console.log(this.onOk)
                //console.log("点击了ok")
                //this.$emit("on-ok");
                var result=new Array();
                this.selectImage.map((item,index)=>{
                    if(item.select)
                    {
                      result.push(item.imgUrl);
                    }
                })
                this.onOk(result)
                 this.show=false;
            },
            onCancel () {
                this.show=false;
            },
            //分类点击事件
            groupEvent(_index){
                this.mid=this.grouplist[_index].id;
                this.hideUploadButton=false
                if(this.mid===-1)
                {
                    this.hideUploadButton=true
                }
                
                this.isShowSelect=false;
                 this.page=1
                this.Sys_MaterialPage()

            },
            //创建分组事件
            categoryGroup(e){
                let than=this;
                this.meunMode.show=true;
                var dom=e.currentTarget.querySelector(".material-popover");
                dom.addEventListener("mouseleave", function () {
                        than.meunMode.show=false;
                    })
            },
            //确定创建分组事件
            oKCategoryGroup(){
                if(this.meunMode.name=="")
                {
                    this.meunMode.tipshow=true;
                    return
                }
                this.meunMode.tipshow=false;
                let than=this;
                this.http.post("api/SysMaterialclassify", {name: this.meunMode.name}).then(result => {
                    if(result.code==200)
                    {
                        than.meunMode.name="";
                        than.meunMode.show=false;
                        than.mid=result.mid;
                        than.$Message.success(result.msg);
                        than.init=true;
                         than.page=1
                        than.Sys_MaterialPage()
                    }else{
                        than.$Message.error(result.msg);
                    }
                        
                        
                });
            },
            //取消创建分组事件
            cancelCategoryGroup(e){
                e.stopPropagation()
                this.meunMode.show=false;
            },
            //显示所选择图片
            showSelect(){
                let that=this;
                this.isShowSelect=true;//设置为选择图片状态
                this.Copy_selectImage= deepClone(this.imglist);//将当前页面的图片数据列表拷贝一份
                this.imglist=[];
                this.selectImage.map((item,index)=>{
                    if(item.select)
                    {
                      that.imglist.push(deepClone(item));
                    }
                })
            },
            //关闭所选图片
            closeSelect()
            {
                let that=this;
                //将拷贝的数据赋予回给原来的数组
                this.imglist = this.Copy_selectImage.map((item, index) => {
                        let _isSelect=false
                        //获取选中的
                        const findItem = that.selectImage.find(p => p.id === item.id && p.select==true) // 返回子项
                        if(findItem)
                        {
                            _isSelect=true
                        }
                        return Object.assign(item, { select: _isSelect });
                    });
                this.isShowSelect=false
            },
            Calculate(){
                let _tmp_count=0;
                 this.selectImage.map((item,index)=>{
                    if(item.select)
                    {
                         _tmp_count++;
                    }
                }) 
                if(_tmp_count>=this.opt_limit)
                 {
                    this.isDisabled=true
                 }
                 else{
                    this.isDisabled=false
                 }
                this.selectImageCount=_tmp_count; 


            },
            //图片点击事件
            SelectImage(index){
                var thisMode=this.imglist[index]
                 if(thisMode.select==false)
                {
                    if(this.isDisabled)
                    {
                        return;
                    }
                    thisMode.select=true;
                    const findItem = this.selectImage.find(p => p.id === thisMode.id) // 返回子项
                    if(!findItem)//如果不存在，直接加入数组
                    {
                        this.selectImage.push(deepClone(thisMode));//加入到选中系列
                    }else
                    {//如果之前点击过存在的，那直接设置操作
                        findItem.select=true;
                    }
                }else{
                    thisMode.select=false;
                    const findIndex = this.selectImage.findIndex(p => p.id === thisMode.id) // 返回子项的下标如果没有值会返回-1
                    if(findIndex!=-1&&this.isShowSelect)//如果是显示所选择的图片时候isShowSelect那么就设置数组不能删除，增加用户体验
                    {
                       // console.log("设置数组")
                        this.selectImage[findIndex].select=false;
                    }else
                    {
                        //console.log("删除数组")
                        this.selectImage.splice(findIndex,1)
                    }
                }
                this.Calculate();
            },
              //分页
            PgaeCallback(pageModel){
                 this.pageSize=pageModel.pageSize;
                 this.page=pageModel.page;
                this.Sys_MaterialPage();
            },
        //请求数据
            Sys_MaterialPage() {
            this.materialLoading=false;
            let that=this;
            let _mid=this.mid;
                this.http.get("api/SysMaterial", {init:this.init, page: this.page, pageSize: this.pageSize, mid:_mid }).then(result => {
                    
                    if(this.init)
                    {
                        this.init=false;
                        this.watermarkSwitch=result.watermarkSwitch;

                        let fixedArray=new Array();
                        fixedArray.push({id:-1, name:'最近使用', count: result.recentTotal,select: (_mid==-1? true:false) });
                        fixedArray.push({id:0, name:'我的素材', count: result.imgTotal,select: (_mid==0? true:false)  });
                        this.grouplist = result.group.map((item, index) => {
                            return Object.assign(item, { select: (_mid==item.id? true:false)  });
                        });
                        this.grouplist=[...fixedArray,...this.grouplist];//合并数组
                    }
                    else
                    {
                        this.grouplist.map((item, index) => {
                            return Object.assign(item, { select: (_mid==item.id? true:false)  });
                        });
                    }

                    this.imglist = result.list.data.map((item, index) => {
                        let _isSelect=false
                        //获取选中的
                        const findItem = that.selectImage.find(p => p.id === item.id && p.select===true) // 返回子项
                        if(findItem)
                        {
                            _isSelect=true
                        }
                        return Object.assign(item, { select: _isSelect });
                    });

              
                    this.totalCount=result.list.dataCount;//分页数
                    this.materialLoading=true;//加载效果


                });
                if(this.page==1)
                {
                    this.$nextTick(function() {
                        this.$refs.pagefun.currentPage=this.page;//修改page组件的页码
                    });
                }
        },
         //选择上传图片按钮事件
      UploadFile(event){
            let willUploadFile = [];
            var fileList = event.target.files;
            console.log(fileList)
            if (willUploadFile.length > this.fileMaxCount || fileList.length > this.fileMaxCount || (willUploadFile.length + fileList.length > this.fileMaxCount)) {
                this.$Message.error('最多只能上传' + this.fileMaxCount + '张图');
                return;
                
            }
       
            this.fileCount = fileList.length;
            this.updateCount = 0;
            //插入新元素前移除后面的元素
            var max_nodes = 16;//最大节点数
            var itemCount = this.imglist.length;//当前节点数
            if ((fileList.length + itemCount) > max_nodes) {
                var removeNode = max_nodes - fileList.length;
                for (var i =itemCount-1; i >= removeNode; i--) {
                    this.imglist.splice(i,1);
                }
            }


            for (var i = 0; i < fileList.length; i++) {
                var f = fileList[i];//先预览图片
                willUploadFile.push({
                    file: f,
                    imgitem:{
                            type:"progress",
                            name:f.name,
                            progress:0
                        }
                });
            }

            if (!willUploadFile.length) {
                return;
            }
            event.target.value = "";
            let that=this;
            //遍历文件信息进行上传
            willUploadFile.forEach(function (item) {
                that.imglist.unshift(item.imgitem);
                that.xhrSend({
                    file: item.file,
                    imgitem: item.imgitem
                });
            });
      },
      xhrSend({ file, imgitem }) {
            const baseUrl = process.env.API_ROOT;//根域名
            let than=this;
            var fd = new FormData();   //构造FormData对象
            fd.append('fimg', file);
            fd.append("mid", than.mid);
            var xhr = new XMLHttpRequest();   //创建对象
            xhr.open('POST',baseUrl+'api/SysMaterial', true);
            // 设置请求头，携带 Authorization token
            let token = store.getters.getToken();
            xhr.setRequestHeader("Authorization", token);


            xhr.onreadystatechange = function () {
               // console.log('state change', xhr.readyState);
                //调用 abort 后，state 立即变成了4,并不会变成0
                //增加自定义属性  xhr.uploaded
                if (xhr.readyState == 4 && xhr.uploaded) {
                    var res = JSON.parse(xhr.responseText);   //返回值
                    if (res.success) {
                        imgitem.type=""
                        imgitem.imgUrl=res.data.imgUrl
                        imgitem.name=res.data.name;
                        than.$Message.success( res.msg);
                        than.updateCount++;
                    } else {//插入失败的消息
                        imgitem.type="error"
                        imgitem.msg=res.msg
                        imgitem.name=file.name;
                        than.$Message.error(res.msg);
                    }

                    //更新成功的数量等于单次选择上传图片的数量才会更新，防止每次上传一张就更新
                     if ( than.fileCount == than.updateCount) {
                         than.init=true;
                         than.page=1
                        than.Sys_MaterialPage();
                    } 
                }

            }

            xhr.onprogress = updateProgress;
            xhr.upload.onprogress = updateProgress;
            function updateProgress(event) {
                if (event.lengthComputable) {

                    console.log("event.loaded="+event.loaded)
                    console.log("event.total="+event.total)
                    var completedPercent = (event.loaded / event.total * 100).toFixed(2);
                    //progressSpan.style.width = completedPercent + '%';
                    imgitem.progress=completedPercent + '%';
                    //progressSpan.innerHTML = completedPercent + '%';
                    //if (completedPercent > 90) {//进度条变色
                    //    progressSpan.classList.add('green');
                    //}
                    if (completedPercent >= 100) {
                        xhr.uploaded = true;
                    }
                    console.log('已上传', completedPercent);
                }
            }
            //注意 send 一定要写在最下面，否则 onprogress 只会执行最后一次 也就是100%的时候
            xhr.send(fd);//发送时  Content-Type默认就是: multipart/form-data;
            return xhr;
        },
         //删除上传失败图片
        delUploadFailed(){
             this.init=true;
            this.Sys_MaterialPage();
        }
        },
      mounted () {
          this.Sys_MaterialPage()
        },
        beforeDestroy () {
           // this.clearCloseTimer();
        }
    };
</script>
<style scoped>
.material-mask { position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index:99999; background-color: rgba(0, 0, 0, 0.55); display: -moz-box; -moz-box-pack: center; -moz-box-align: center; display: -webkit-box; -webkit-box-pack: center; -webkit-box-align: center; display: box; box-pack: center; box-align: center; }
.material-dialog { display: inline-block; white-space: normal; -webkit-border-radius: 4px; border-radius: 4px; background-color: #FFFFFF; -webkit-box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1); box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1); width: 980px; min-height: 600px; min-width: 600px; box-sizing: border-box; }
.material-dialog .material-hd { display: flex; justify-content: center; align-items: center; padding: 0 32px; line-height: 72px; height: 72px; }
.material-dialog .material-hd h3 { flex: 1; font-weight: 400; font-size: 16px; }
.material-dialog .material-hd i { font-size: 28px; color: #9B9B9B; cursor: pointer }
.material-dialog .material-bd { }
.material-dialog .material-bd .material-panel { }
.material-dialog .material-bd .material-panel .material-grid { display: flex; }
.material-dialog .material-bd .material-panel .material-grid .material-menu { width: 190px;  border-right: 1px solid #E4E8EB; display: -webkit-flex; display: flex; -webkit-flex-direction: column; flex-direction: column; -webkit-flex-wrap: nowrap; flex-wrap: nowrap; -webkit-justify-content: space-between; justify-content: space-between; -webkit-align-items: stretch; align-items: stretch; -webkit-align-content: stretch; align-content: stretch; }
.material-dialog .material-bd .material-panel .material-grid .material-menu .munu-box {   -webkit-box-flex: 1; -webkit-flex: 1; flex: 1; }
.material-dialog .material-bd .material-panel .material-grid .material-menu .munu-box .group-list{ max-height: 555px;overflow-y: auto;}
.material-dialog .material-bd .material-panel .material-grid .material-menu .munu-box .item { padding-left: 28px; line-height: 40px; cursor: pointer }
.material-dialog .material-bd .material-panel .material-grid .material-menu .munu-box .item em { font-style: normal; font-size: 1.4rem; color: #9A9A9A; }
.material-dialog .material-bd .material-panel .material-grid .material-menu .munu-box .item span { font-size: 1.4rem; color: #353535; width: auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; word-wrap: normal; max-width: 8em; font-weight: 400; }
.material-dialog .material-bd .material-panel .material-grid .material-menu .munu-box .item:hover { border-left-color: transparent; background-color: rgba(0, 0, 0, 0.03); }
.material-dialog .material-bd .material-panel .material-grid .material-menu .munu-box .item.current { border-left-color: transparent; background-color: rgba(0, 0, 0, 0.03); }
.material-dialog .material-bd .material-panel .material-grid .material-menu .category_add { padding-left: 28px; line-height: 40px; font-size: 1.4rem; color: #576b95; cursor: pointer; }


.material-dialog .material-bd .material-panel .material-grid .material-context { flex: 1; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar { text-align: right }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .tips { font-size: 1.5rem; color: #9a9a9a; display: inline-block; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .tips .tipsbox { padding-left: 5px; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .tips .tipsbox i { font-size: 1.6rem; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .tips .tipsbox:hover .material-popover { opacity: 1; visibility: visible; padding-top: 16px; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .tips .tipsbox .material-popover { font-size: 1.3rem; }

.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .operate-box { display: inline-block; padding: 0 28px 0 18px }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .operate-box .file-btn { display: inline-block; width: 102px; height: 36px; line-height: 36px; text-align: center; background-color: #FBFBFB; color: #353535; border-radius: 3px; font-size: 14px; cursor: pointer; border: 1px #E4E8EB solid; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-bar .operate-box .file-btn:hover { background-color: #EFF0F2; color: #858585 }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist { position: relative; padding: 0 28px; margin-top: 30px; min-height: 346px; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist:after { display: block; clear: both; content: ""; visibility: hidden; height: 0 }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item { cursor: pointer; position: relative; float: left; width: 110px; margin: 0 13px 20px 0; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item:nth-child(6n) { margin-right: 0; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .img { position: relative; display: block; width: 110px; height: 110px; -webkit-background-size: contain; background-size: contain; background-position: 50% 50%; background-repeat: no-repeat; box-sizing: border-box; border-radius: 2px; overflow: hidden; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item:hover .img { box-shadow: 0 0 0 2px #07C160 inset; }

.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item strong { margin-top: 8px; display: block; width: auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; word-wrap: normal; font-weight: 400; line-height: 20px; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .checkbox { position: absolute; top: 5px; left: 5px; width: 20px; height: 20px; border: 1px solid #fff; border-radius: 1px; background-color: rgba(0, 0, 0, 0.2); }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item.selected .checkbox { background-color: #07C160; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item.selected .checkbox:before { content: ''; position: absolute; top: 5px; left: 4px; width: 11px; height: 6px; border-left: 1px solid #fff; border-bottom: 1px solid #fff; -ms-transform: rotate(-45deg); transform: rotate(-45deg); }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item.selected .img { box-shadow: 0 0 0 2px #07C160 inset; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item.selected .img:before { content: ''; position: absolute; top: 0; right: 0; bottom: 0; left: 0; background-color: #07C160; opacity: 0.1; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item.disabled { opacity: .5; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item.disabled .checkbox { display: none }
.material-dialog .material-ft { display: flex; padding: 24px 28px; }
.material-dialog .material-ft .calculate { position: relative; font-size: 1.5rem; width: 20%; line-height: 39px; color: #353535 }
.material-dialog .material-ft .calculate span { color: #576b95; cursor: pointer }
.material-dialog .material-ft .calculate span:last-child { margin-left: 10px;  }
.material-dialog .material-ft .operate { flex: 1; text-align: center }
.material-dialog .material-ft .operate .file-btn { display: inline-block; width: 102px; height: 36px; line-height: 36px; text-align: center; background-color: #FBFBFB; color: #353535; border-radius: 3px; font-size: 14px; cursor: pointer; border: 1px #E4E8EB solid; }
.material-dialog .material-ft .operate .file-btn:hover { background-color: #EFF0F2; color: #858585 }
.material-dialog .material-ft .other { width: 20%; }
.material-loading { position: absolute; top: 50%; left: 50%; margin-top: -20px; margin-left: -20px; height: auto; font-size: 0; color: transparent; }
.material-loading:after { content: " "; display: inline-block; vertical-align: middle; width: 0; height: 100%; overflow: hidden; }
.material-loading:before { content: " "; background: transparent url(data:image/gif;base64,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) no-repeat 0 0; width: 40px; height: 40px; vertical-align: middle; display: inline-block; }




.yjui-btn + .yjui-btn { margin-left: 10px; }

.material-mask .material-toptips { position: fixed; top: 0; left: 0; text-align: center; width: 100%; z-index: 50000; }
.material-mask .material-toptips span { display: inline-block; min-width: 280px; padding: 10px 30px; color: #FFFFFF; font-size: 1.4rem; }
.material-mask .material-toptips span.material-success { background-color: #07C160; }
.material-mask .material-toptips span.material-error { background-color: #EAA000; }

.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .upload-status { position: relative; display: block; width: 110px; height: 110px; -webkit-background-size: contain; background-size: contain; background-position: 50% 50%; background-repeat: no-repeat; box-sizing: border-box; border-radius: 2px; overflow: hidden; box-shadow: 0 0 0 2px #E4E8EB inset; display: -moz-box; -moz-box-pack: center; -moz-box-align: center; display: -webkit-box; -webkit-box-pack: center; -webkit-box-align: center; display: box; box-pack: center; box-align: center; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .upload-status .progressbox { width: 80%; background: #E4E8EB; border-radius: 2px; position: relative; text-align: center; color: #fff; font-size: 1.2rem; height: 4px; overflow: hidden; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .upload-status .progressbox span { background: #07C160; border-radius: 2px; height: 4px; position: absolute; left: 0; top: 0; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .upload-status .error-text { width: 80%; color: #ff0000; font-size: 1.4rem; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .upload-status .error-text .del { display: block; position: absolute; left: 0; right: 0; top: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.7); visibility: hidden; opacity: 0; transition: all .3s; display: -moz-box; -moz-box-pack: center; -moz-box-align: center; display: -webkit-box; -webkit-box-pack: center; -webkit-box-align: center; display: box; box-pack: center; box-align: center; }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .upload-status .error-text .del i { font-size: 1.4rem; font-style: normal; color: #576b95 }
.material-dialog .material-bd .material-panel .material-grid .material-context .material-imglist .wrap-item .upload-status .error-text:hover .del { visibility: visible; opacity: 1; }

.popover_wrp { display: inline; position: relative; }
.material-popover { opacity: 0; visibility: hidden; width: 280px; position: absolute; z-index: 500; text-align: left; color: #353535; line-height: 1.6; white-space: normal; word-wrap: break-word; -webkit-transition: opacity .3s; transition: opacity .3s; left: 50%; -ms-transform: translateX(-50%); transform: translateX(-50%); }
.material-popover .popover_inner { position: relative; padding: 24px; box-sizing: border-box; background: #FFFFFF; box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1); border-radius: 2px; }
.material-popover .popover_inner:before { content: " "; width: 8px; height: 8px; background-color: #FFFFFF; box-shadow: 0 2px 10px 0 #D4D4D4; transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0); -ms-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0); -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0); position: absolute; left: 50%; margin-left: -4px; top: -4px; }
.material-popover .popover_inner:after { content: " "; background-color: #FFFFFF; position: absolute; height: 10px; top: 0; left: 0; right: 0; }
.material-popover .popover_inner .popover_context .form_group { display: -webkit-box; display: -webkit-flex; display: flex; }
.material-popover .popover_inner .popover_context { }
.material-popover .popover_inner .popover_context .form_group .form_input { flex: 1 }
.material-popover .popover_inner .popover_context .form_group .form_label { width: 80px; font-size: 1.4rem; }
.material-popover .popover_inner .popover_context .form_group .form_input input { display: table-cell; width: 100%; padding: 8px 10px; -webkit-box-sizing: border-box; box-sizing: border-box; background: #FFFFFF; border: 1px solid #E4E8EB; border-radius: 3px; outline: 0 }
.material-popover .popover_inner .popover_context .form_group .form_input .form_msg_warn { color: #FA5151; padding-top: 10px; }
.material-popover .popover_inner .popover_bar { display: -webkit-box; display: -webkit-flex; display: flex; justify-content: center; align-items: center; padding-top: 30px; }
.material-popover .popover_inner .popover_bar button { flex: 1; outline: 0 }


.filerows { display: -webkit-box; display: -webkit-flex; display: flex; justify-content: center; align-items: center; }
.filerows .filesbox { -webkit-box-flex: 1; -webkit-flex: 1; flex: 1; }
.filesbox .imgboxs, .filesbox .upload-btn { display: inline-block; width: 58px; height: 58px; text-align: center; line-height: 58px; border: 1px solid #c0ccda; border-radius: 4px; overflow: hidden; background: #fff; position: relative; box-shadow: 2px 2px 5px rgba(0,0,0,.1); margin-right: 4px; box-sizing: border-box; }
.filesbox .upload-btn { border: 1px dashed #c0ccda; }
.filesbox .imgboxs img { width: 100%; height: 100%; display: inline-block; vertical-align: top; }
.filesbox .imgboxs:hover .upload-cover { opacity: 1; }
.filesbox .upload-cover { opacity: 0; position: absolute; top: 0; bottom: 0; left: 0; right: 0; background: rgba(0,0,0,.6); transition: opacity .3s; }
.filesbox .upload-cover i { font-size: 20px; color: #fff; cursor: pointer; }
.filesbox .files { position: absolute; left: -1000px; top: 52px; heigth: 26px; cursor: pointer; filter: Alpha(opacity=0); -moz-opacity: 0; opacity: 0; }
</style>


// WEBPACK FOOTER //
// src/components/Material/Material.vue